import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { kebabCase } from "lodash";

export default function DisplayContentHeader(props) {
  const {
    slug = "",
    grandparent = "",
    grandparentSlug = "",

    parent = "",
    parentSlug = "",
    parentSubtitle = "",
    title,
    titleClass = "",
    date = "",
    endDate = "",
    relatedPerson = "",
    relatedPersonType = "",
    relatedPersonSlug = "",
  } = props;
  //console.log(title, titleClass);
  if (!title) return <></>;
  const last = title.charAt(title.length - 1);
  let colon = ":";

  if (last === "?" || last === "!") {
    colon = "";
  }

  return (
    <React.Fragment>
      <header>
        <div className="display-content-header">
          {grandparent ? (
            <h2
              className="has-text-weight-semibold is-size-5 inline"
              id={`parent___${kebabCase(grandparent)}`}
            >
              {parentSlug ? (
                <Link
                  to={grandparentSlug}
                  title={grandparent}
                  className="c-inh"
                >
                  {grandparent}
                </Link>
              ) : (
                <>{grandparent}</>
              )}{" "}
              &gt;{" "}
            </h2>
          ) : null}
          {parent ? (
            <h2
              className="has-text-weight-semibold is-size-5 inline"
              id={`parent___${kebabCase(parent)}`}
            >
              {parentSlug ? (
                <Link to={parentSlug} title={parent} className="c-inh">
                  {parent}
                </Link>
              ) : (
                <>{parent}</>
              )}{" "}
              &gt; {parentSubtitle ? <>{parentSubtitle}</> : null}
            </h2>
          ) : null}

          {titleClass ? (
            <h2
              className={`title is-size-3 has-text-weight-bold is-bold-light mb-c mt-c ${titleClass} ${`title___${kebabCase(
                title
              )}`}`}
              id={`title___${kebabCase(title)}`}
            >
              {slug ? (
                <>
                  <Link to={slug} title={title}>
                    {title}
                  </Link>
                </>
              ) : (
                <>
                  {title}
                  {colon}
                </>
              )}
            </h2>
          ) : (
            <h2
              className={`title is-size-3 has-text-weight-bold is-bold-light mb-c mt-c ${`title___${kebabCase(
                title
              )}`}`}
              id={`title___${kebabCase(title)}`}
            >
              {slug ? (
                <>
                  <Link to={slug} title={title}>
                    {title}
                  </Link>
                </>
              ) : (
                <>
                  {title}
                  {colon}
                </>
              )}
            </h2>
          )}
          {date ? (
            <h6
              className="title is-size-6 has-text-weight-bold is-bold-light"
              id={`date___${kebabCase(title)}`}
            >
              {endDate ? (
                <span>
                  {date} - {endDate}
                </span>
              ) : (
                <span>{date}</span>
              )}
            </h6>
          ) : null}
          {relatedPerson
            ? renderRelatedPerson(
                relatedPerson,
                relatedPersonType,
                relatedPersonSlug
              )
            : null}
        </div>
      </header>
    </React.Fragment>
  );
}

DisplayContentHeader.propTypes = {
  parent: PropTypes.string,
  parentSlug: PropTypes.string,
  parentSubtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  relatedPerson: PropTypes.string,
  relatedPersonType: PropTypes.string,
  relatedPersonSlug: PropTypes.string,
};

function renderRelatedPerson(
  relatedPerson = "",
  relatedPersonType = "",
  relatedPersonSlug = ""
) {
  if (relatedPerson) {
    let thisRelated = "";

    if (relatedPersonSlug) {
      thisRelated = (
        <Link to={relatedPersonSlug} title={relatedPerson} className="c-inh">
          {relatedPerson}
        </Link>
      );
    } else {
      thisRelated = relatedPerson;
    }

    if (relatedPersonType) {
      return (
        <div className="content">
          <h4
            className="title is-size-6 has-text-weight-bold is-bold-light mb-c"
            id={`related_type___${kebabCase(relatedPersonType)}`}
          >
            {relatedPersonType}
          </h4>
          <h2
            className="title is-size-5 has-text-weight-normal mt-c"
            id={`related___${kebabCase(thisRelated)}`}
          >
            {thisRelated}
          </h2>
        </div>
      );
    } else {
      return (
        <div className="content">
          <h2
            className="title is-size-5 has-text-weight-normal mt-c"
            id={`related___${kebabCase(thisRelated)}`}
          >
            {thisRelated}
          </h2>
        </div>
      );
    }
  }
}
